import * as React from 'react'
import PropTypes from 'prop-types'
import { ContentWrapper, Headline, Description, TagCopy, LogoContainer, Logo } from './styles'

export function HeroHeader({
  headingCopy,
  subHeadlineCopy,
  addTagCopy,
  tagCopy,
  useLogo,
  logoUrl,
  logoAlt,
}) {
  return (
    <ContentWrapper>
      {useLogo && (
        <LogoContainer>
          <Logo src={logoUrl} alt={logoAlt} />
        </LogoContainer>
      )}
      {!useLogo && <Headline>{headingCopy}</Headline>}
      <Description>{subHeadlineCopy}</Description>
      {addTagCopy && <TagCopy>{tagCopy}</TagCopy>}
    </ContentWrapper>
  )
}

HeroHeader.propTypes = {
  headingCopy: PropTypes.string.isRequired,
  useLogo: PropTypes.bool,
  logoUrl: PropTypes.string,
  logoAlt: PropTypes.string,
  subHeadlineCopy: PropTypes.string.isRequired,
  addTagCopy: PropTypes.bool.isRequired,
  tagCopy: PropTypes.string.isRequired,
}
